import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import cn from 'classnames'
import { pathOr } from 'ramda'

import IconField from './IconField'
import { BUTTON_OFF } from '../../../../constants'
import { amenityFieldName } from '../constants'
import { pushAmenitySeeAll } from '../../../../../../helpers/gtm'



class Amenities extends PureComponent {
  componentWillMount = () => {
    const { amenities } = this.props
    this.initState(amenities)
  }

  componentWillReceiveProps = (next) => {
    const { amenities } = this.props
    if (amenities !== next.amenities) {
      this.initState(next.amenities)
    }
  }

  initState = (amenities) => {
    const expanded = pathOr(false, ['expanded'], this.state)
    const { icons } = this.props
    this.setState({
      expanded,
      buttons: icons.map(
        id => ({
          id,
          value: pathOr(BUTTON_OFF, [id])(amenities),
        }),
      ),
    })
  }

  expand = (e) => {
    e.stopPropagation()
    const expanded = pathOr(false, ['expanded'], this.state)
    this.setState({
      ...this.state,
      expanded: !expanded,
    })
    pushAmenitySeeAll()
  }

  expandLink = () => {
    const { more, less } = this.props
    return pathOr(false, ['expanded'], this.state) ? less : more
  }

  render() {
    const {
      blockName, icons, iconTitles, onAmenityChange, eventTrackingData,
  } = this.props
    const { expanded, buttons } = this.state

    return (
      <div className="amenities">
        <div className="amenities-header">
          <div className="amenities-header__name">
            {blockName}
          </div>
          {icons.length > 3 && (
            <div
              role="button"
              tabIndex="0"
              onClick={this.expand}
              onKeyDown={() => {}}
              className="amenities-header__show-link"
            >
              {this.expandLink()}
            </div>
          )}
        </div>
        <div className="amenities-items">
          {
            buttons && buttons.map((amenity, key) => (
              <Field
                key={key}
                name={amenityFieldName(amenity.id)}
                component={IconField}
                onChange={onAmenityChange}
                props={{
                  iconId: amenity.id,
                  additionalClass: cn(key > 2 && !expanded && 'hidden'),
                  titles: iconTitles,
                  value: amenity.value,
                  eventTrackingData: eventTrackingData,
                }}
              />
            ))
          }
        </div>
      </div>
    )
  }
}


Amenities.propTypes = {
  blockName: PropTypes.string.isRequired,
  more: PropTypes.string.isRequired,
  less: PropTypes.string.isRequired,
  iconTitles: PropTypes.shape({
    disabledPeople: PropTypes.string.isRequired,
    petsAllowed: PropTypes.string.isRequired,
    parking: PropTypes.string.isRequired,
    pool: PropTypes.string.isRequired,
    sportsHall: PropTypes.string.isRequired,
    meetingRoom: PropTypes.string.isRequired,
  }),
  icons: PropTypes.arrayOf(PropTypes.string.isRequired),
  amenities: PropTypes.objectOf(PropTypes.string),
  onAmenityChange: PropTypes.func.isRequired,
  eventTrackingData: PropTypes.arrayOf(String),
}

export default Amenities
